import { graphql } from '@/graphql/generated/seller';

export const asnsQuery = graphql(`
  query AsnsQuery($limit: Int!, $offset: Int!, $where: AsnsBoolExp!, $orderBy: [AsnsOrderByExp!]!) {
    asns(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      reference
      expectedAt
      locationName
      status
      qtyExpected
      qtyReceived
      closedAt
      createdAt
    }
    asnsAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);

export const returnsQuery = graphql(`
  query ReturnsQuery(
    $limit: Int!
    $offset: Int!
    $where: ReturnsBoolExp!
    $orderBy: [ReturnsOrderByExp!]!
  ) {
    returns(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      status
      returnCategory
      createdAt
      closedAt
      fromAddressContactName
      order {
        name
      }
      location {
        name
      }
    }
    returnsAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
